/* eslint-disable no-shadow */

import {
  GetterTree, MutationTree, ActionTree, Module
} from 'vuex';
import IBusiness from '@/models/interfaces/IBusiness';
import BusinessSizeType from '@/enums/business/BusinessSizeType';
import BusinessType from '@/enums/business/BusinessType';
import Business from '@/models/business/Business';
import BusinessState from '../states/business-state';
import IBusinessState from '../states/interfaces/business-state.d';
import IRootState from '../states/interfaces/index.d';

export const state: IBusinessState = new BusinessState();

export const getters: GetterTree<IBusinessState, IRootState> = {
  business: (state): IBusiness => state.business,
  businessSize: (state): BusinessSizeType => state.business.businessSize,
  businessType: (state): BusinessType => state.business.businessType,
  businessTimeEstablished: (state) => state.business.businessTimeEstablished,
  requiredFleetSize: (state) => state.business.requiredFleetSize,
  existingFleetSize: (state) => state.business.existingFleetSize,
  businessName: (state) => state.business.businessName
};

export const mutations: MutationTree<IBusinessState> = {
  setBusinessSize: (state: IBusinessState, businessSize: BusinessSizeType) => {
    state.business.businessSize = businessSize;
  },
  setBusinessType: (state: IBusinessState, businessType: BusinessType) => {
    state.business.businessType = businessType;
  },
  setTimeEstablished: (state: IBusinessState, businessTimeEstablished: number) => {
    state.business.businessTimeEstablished = businessTimeEstablished;
  },
  setExistingFleetSize: (state: IBusinessState, existingFleetSize: number) => {
    state.business.existingFleetSize = existingFleetSize;
  },
  setRequiredFleetSize: (state: IBusinessState, requiredFleetSize: number) => {
    state.business.requiredFleetSize = requiredFleetSize;
  },
  setBusinessName: (state: IBusinessState, businessName: string) => {
    state.business.businessName = businessName;
  },
  setResetBusinessValues: (state: IBusinessState) => {
    state.business = new Business();
  }
};

export const actions: ActionTree<IBusinessState, IRootState> = {
  submitBusinessSize({ commit }, businessSize: BusinessSizeType) {
    commit('setBusinessSize', businessSize);
  },
  submitBusinessType({ commit }, businessType: BusinessType) {
    commit('setBusinessType', businessType);
  },
  submitTimeEstablished({ commit }, businessTimeEstablished: number) {
    commit('setTimeEstablished', businessTimeEstablished);
  },
  submitExistingFleetSize({ commit }, existingFleetSize: number) {
    commit('setExistingFleetSize', existingFleetSize);
  },
  submitRequiredFleetSize({ commit }, requiredFleetSize: number) {
    commit('setRequiredFleetSize', requiredFleetSize);
  },
  submitBusinessName({ commit }, businessName: string) {
    commit('setBusinessName', businessName);
  },
  submitResetBusinessValues({ commit }) {
    commit('setResetBusinessValues');
  }
};

export const businessModule: Module<IBusinessState, IRootState> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
